export default "__VITE_ASSET__55f4bd96__"